module.exports = __webpack_public_path__ + "static/media/image15.98307329.png";